import Moon from './Moon'
import Sun from './Sun'

export default {
  moon: Moon,
  sun: Sun,
}
